import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CssbuySpreadsheet from "../pages/cssbuy-spreadsheet/page";

// Placeholder pages with proper SEO structure
import CategoriesPage from "../pages/categories/page";
import ShippingPage from "../pages/shipping/page";
import ReviewsPage from "../pages/reviews/page";
import SafetyPage from "../pages/safety/page";
import AboutPage from "../pages/about/page";
import DisclaimerPage from "../pages/disclaimer/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import CssbuyReviewPage from "../pages/cssbuy-review/page";
import GuidesPage from "../pages/guides/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  // Language-specific home pages (all use same Home component, i18n handles translation)
  { path: "/", element: <Home /> },
  { path: "/pt/", element: <Home /> },
  { path: "/de/", element: <Home /> },
  { path: "/en/", element: <Home /> },

  // Article pages (generic template, data-driven by slug)
  { path: "/article/:slug/", element: <ArticlePage /> },
  { path: "/pt/article/:slug/", element: <ArticlePage /> },
  { path: "/de/article/:slug/", element: <ArticlePage /> },
  { path: "/en/article/:slug/", element: <ArticlePage /> },
  
  // Language-prefixed routes
  { path: "/pt/cssbuy-spreadsheet/", element: <CssbuySpreadsheet /> },
  { path: "/de/cssbuy-spreadsheet/", element: <CssbuySpreadsheet /> },
  { path: "/en/cssbuy-spreadsheet/", element: <CssbuySpreadsheet /> },
  
  { path: "/pt/categories/", element: <CategoriesPage /> },
  { path: "/de/categories/", element: <CategoriesPage /> },
  { path: "/en/categories/", element: <CategoriesPage /> },
  
  { path: "/pt/shipping/", element: <ShippingPage /> },
  { path: "/de/shipping/", element: <ShippingPage /> },
  { path: "/en/shipping/", element: <ShippingPage /> },
  
  { path: "/pt/reviews/", element: <ReviewsPage /> },
  { path: "/de/reviews/", element: <ReviewsPage /> },
  { path: "/en/reviews/", element: <ReviewsPage /> },
  
  { path: "/pt/guides/", element: <GuidesPage /> },
  { path: "/de/guides/", element: <GuidesPage /> },
  { path: "/en/guides/", element: <GuidesPage /> },
  
  // Default (Portuguese) routes for SEO
  { path: "/cssbuy-spreadsheet/", element: <CssbuySpreadsheet /> },
  { path: "/categories/", element: <CategoriesPage /> },
  { path: "/shipping/", element: <ShippingPage /> },
  { path: "/reviews/", element: <ReviewsPage /> },
  { path: "/guides/", element: <GuidesPage /> },
  { path: "/cssbuy-review/", element: <CssbuyReviewPage /> },
  
  // Legal / Trust pages (shared across languages)
  { path: "/safety/", element: <SafetyPage /> },
  { path: "/about/", element: <AboutPage /> },
  { path: "/disclaimer/", element: <DisclaimerPage /> },
  { path: "/privacy/", element: <PrivacyPage /> },
  { path: "/terms/", element: <TermsPage /> },
  
  // 404
  { path: "*", element: <NotFound /> },
];

export default routes;